export default __webpack_public_path__ + "static/media/9.bebc0907.webp";